export enum TipoComprobanteMovimiento {
    RemitoCargamentoRecepcion,
    ReciboCargamentoRecepcion,
    RemitoSalida
}